import * as React from 'react';

import { RRFInput } from './RRFInput';
import { dispatch } from '../../../utils/generalUtils';
import { actions } from 'react-redux-form';

export interface IInputRowProps {
    label: string;
    quesNo: string;
    type: string;
    placeholder: string;
    onChange?: (e) => void;
    model?: string;
    defaultValue?: string;
}

export class InputRow extends React.PureComponent<IInputRowProps, {}> {
    constructor(props: IInputRowProps) {
        super(props);
    }

    render() {
        const { model, placeholder, onChange, label, quesNo, type } = this.props;
        return <div className="question-row">
            <div className="question" >
                {quesNo ? <div className="question-no" >{quesNo}</div> : ''}
                <RRFInput
                    model={model || ''}
                    type={type}
                    placeholder={placeholder}
                    id="state"
                    defaultValue={this.props.defaultValue}
                    onChange={onChange}
                    label={label}
                />
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/InputRow.tsx